import type { FC } from 'react';
import { lazy, useEffect } from 'react';
import { useTrFlags } from 'src/hooks/use-tr-flags';

const Routes = lazy(() => import('./transparency-routes'));

export const Transparency: FC = () => {
  const trFlags = useTrFlags();
  useEffect(() => {
    if (!trFlags.userCanAccess) throw trFlags.error;
    // oxlint-disable-next-line exhaustive-deps
  }, []);
  return <>{trFlags.userCanAccess && <Routes />}</>;
};
